// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Pencil: React.FC<{ width?: number; height?: number }> = ({ width = 13, height = 13 }) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height}>
            <path
                fill="currentColor"
                transform="translate(0.0234375 0)"
                d="M8.2734375 0.9921875L7.21875 2.046875L10.453125 5.28125L11.507812 4.2265625C11.8125 3.921875 12 3.4765625 12 3.03125C12 2.5859375 11.8125 2.140625 11.507812 1.8359375L10.664062 0.9921875C10.359375 0.6875 9.9140625 0.5 9.46875 0.5C9.0234375 0.5 8.578125 0.6875 8.2734375 0.9921875ZM6.421875 2.84375L1.3828125 7.8828125C1.125 8.140625 0.9375 8.4453125 0.84375 8.796875L0.0234375 11.796875C-0.0234375 11.984375 0.0234375 12.195312 0.1640625 12.335938C0.3046875 12.476562 0.515625 12.546875 0.7265625 12.476562L3.703125 11.65625C4.0546875 11.5625 4.359375 11.375 4.6171875 11.117188L9.65625 6.078125L6.421875 2.84375Z"
            />
        </svg>
    );
};

export default React.memo(Pencil);
